export const CANCEL_ROUTE = '/cancel-subscription';
